import {type PropsWithChildren, createContext, use, useMemo} from 'react'
import type {UpsellInfo} from '../types/rules-types'

const defaultUpsellInfo: UpsellInfo = {
  rulesets: {
    featureEnabled: false,
    cta: {
      visible: false,
    },
  },
  enterpriseRulesets: {
    featureEnabled: false,
    cta: {
      visible: false,
    },
  },
  organization: false,
  askAdmin: false,
}

export const UpsellInfoContext = createContext<UpsellInfo>(defaultUpsellInfo)

export function UpsellInfoProvider({children, upsellInfo}: PropsWithChildren<{upsellInfo?: UpsellInfo}>) {
  const value = useMemo(() => upsellInfo ?? defaultUpsellInfo, [upsellInfo])
  return <UpsellInfoContext value={value}>{children}</UpsellInfoContext>
}

export function useUpsellInfoContext(): UpsellInfo {
  const context = use(UpsellInfoContext)
  if (!context) {
    throw new Error('useUpsellInfoContext must be used within a UpsellInfoProvider')
  }
  return context
}
